import { defineMessages } from 'react-intl';
import { cloneDeepSchema } from '@plone/volto/helpers/Utils/Utils';

const messages = defineMessages({
  reviews: {
    id: 'reviews',
    defaultMessage: 'Testimonianze',
  },
  slides: {
    id: 'slides',
    defaultMessage: 'Slides',
  },
  addSlide: {
    id: 'add_slides',
    defaultMessage: 'Aggiungi una slide',
  },
  slide_title: {
    id: 'slide_title',
    defaultMessage: 'Titolo',
  },
  slide_description: {
    id: 'slide_description',
    defaultMessage: 'Descrizione',
  },
});

const ReviewsBlockSchema = (props) => {
  const { intl } = props;

  return {
    title: intl.formatMessage(messages.reviews),
    block: 'reviews',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['items'],
      },
    ],

    properties: {
      items: {
        title: intl.formatMessage(messages.slides),
        widget: 'object_list',
        schema: {
          title: 'Slide',
          addMessage: intl.formatMessage(messages.addSlide),
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: [], //['title'],
            },
          ],
          properties: {
            // title: {
            //   title: intl.formatMessage(messages.slide_title),
            //   placeholder: 'Nome e Cognome',
            // },
          },
          required: [],
        },
      },
    },
    required: [],
  };
};

export default ReviewsBlockSchema;
